import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { KtLogsModel } from "./kt-logs-model";

export class KtLogsGridModel extends KtLogsModel {}

export class KTGridPostParams extends GridPostParams {
    // search_text: string = ''
}

export class KtLogsListingModel extends GridModel<KtLogsGridModel> {}
